import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from 'apa/actions';
import { Redirect } from 'react-router-dom';
import autobind from 'autobind-decorator';
import {Alert, Container} from 'reactstrap'
import Loading from 'apa/components/Loading';
import {CodeDetails} from 'apa/containers/TrainingOverview';
import {NavLink} from 'react-router-dom'


@connect(
    state => ({
        isLoading: state.apa.isLoading,
        user: state.apa.user
    }),
    dispatch => ({
        login: (username, password) => (dispatch(login(username, password)))
    })
)
export default class Home extends Component {

    render() {
        const isLoading = this.props.isLoading;
        if(isLoading) {
            return <Loading/>
        }
        const user = this.props.user;
        const attempts = user.access_code.attempts
        const status = user.access_code.status;
        const results = user.access_code.results;
        const {max, correct, percentage} = results
        if(status === 0) {
            return <Redirect to={'/training/test/'}/>
        }
        let color, msg, msg1;
        if(status==1) {
            color = 'danger'
            msg = 'Achtung!'
            msg1 = 'Sie haben die Prüfung nicht bestanden.'
        } else if(status==2 && attempts > 0 ) {
            color = 'warning'
            msg = 'Achtung!'
            msg1 = 'Sie haben die Prüfung nicht bestanden. Eine Wiederholung ist möglich.'
        }else if(status==2 && attempts == 0 ) {
            color = 'warning'
            msg = 'Achtung!'
            msg1 = 'Sie haben die Prüfung nicht bestanden. Keine weiteren Versuche erlaubt'
        } 
        else {
            color = 'success'
            msg = 'Glückwunsch!'
            msg1 = 'Sie haben die Prüfung bestanden.'
        }
        return (
            <Container style={{'margin': '3em auto', 'width': '40em'}}>
                <Alert color={color}>
                    <h1>
                        {msg}
                    </h1>
                    <p>
                        {msg1}
                    </p>
                    <p>
                        Punktzahl: {correct} / {max} ({Math.round(percentage)} %)
                    </p>
                </Alert>
                {
                  status==2 && attempts > 0 ?
                    (
                        <p>
                            <a className="btn btn-primary" href='/training/test'>{`Wiederholen Sie Ihren Test (${attempts})`}</a>
                        </p>
                    ):(
                        <p>
                            <a className="btn btn-primary" href="/training/do">Zurück zur Präsentation</a>
                        </p>
                    )
                }
                
                <CodeDetails codeDetails={user.access_code} hideID={true} />
            </Container>
        )
    }
}

Home.propTypes = {
    login: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    errors: PropTypes.object
}
